import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=da33e0ea&scoped=true"
import script from "./menuItem.vue?vue&type=script&lang=js"
export * from "./menuItem.vue?vue&type=script&lang=js"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=da33e0ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da33e0ea",
  null
  
)

export default component.exports